import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import './App.scss';
import {useLocation} from 'react-router-dom';
import loadConfig from './utils/configLoader/LoadConfig';
import {
  updateHighestPageHit,
  updateIndexSource,
  updateIsDealerHostApplication,
  updateOptimizelyExperimentData,
  updatePrequalSource,
  updateShowModalFlag,
  updateSpecialEvent,
  updateTier3PACode,
  updateCountryCode, updateModalUpdateFlag, updateLanguageCode, updateConfig
} from './redux/app-state-slice';
import {
  getConfigService,
  getMaintenanceStatusService
} from './Services/MaintenanceStatusService/MaintenanceStatusService';
import loadConfigFromSource from './utils/configLoader/LoadConfigFromSource';
import loadCustomerDataFromInput from './utils/LoadCustomerDataFromInput';
import initializeAxiosInterceptor from './utils/axios';
import PrequalRouteSwitch from './Routes/PrequalRouteSwitch';
import {listenTier3ModalEventOpen} from './utils/tier-3-modal-close/PrequalCloseEvent';
import {SPECIAL_EVENT_PAGE_NAME} from './utils/constants/constants';
import {determineLanguageCode} from './utils/functions/determineLanguageCode';

export function reloadFn() {
  if (window.performance.getEntriesByType('navigation') !== undefined) {
    if (performance.getEntriesByType('navigation')[0].type === 'reload') {
      window.location.pathname = '/finance/prequalify/';
    }
  }
}

// DO NOT REMOVE ESLINT COMMENTS
// eslint-disable-next-line consistent-return
export function initializeMouseflow(appConfig) {
  if (appConfig.exrEnv !== 'prod' && appConfig.exrEnv !== 'prodAkamai') {
    window._mfq = window._mfq || [];
    // eslint-disable-next-line func-names
    (function () {
      const mf = document.createElement('script');
      mf.type = 'text/javascript';
      mf.defer = true;
      mf.src = `//cdn.mouseflow.com/projects/${appConfig.mouseflowKey}.js`;
      document.getElementsByTagName('head')[0].appendChild(mf);
    })();
    return true;
  }
}

export function checkIfIsDealerHostApplication(prequalSource) {
  return prequalSource?.split('-')[0] === 'DCF';
}


function App({prequalSource, prequalInput, indexSource}) {
  const [apiLoading, setApiLoading] = useState(true);
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const customerData = useSelector((state) => state.customerData);

  let appConfig;

  const languageCode=determineLanguageCode(window.location.host);
  const isDealerHost = prequalSource?.split('-')[0] === 'DCF';
  const isECOMHost = prequalSource?.split('-')[0] === 'ECOM';
  if (isDealerHost || isECOMHost) {
    dispatch(updateIsDealerHostApplication(true));
    dispatch(updateIndexSource(indexSource));
    dispatch(updatePrequalSource(prequalSource));
    appConfig = loadConfigFromSource(prequalSource);
  } else {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const qrCode = params.get('qrcid');

    if (qrCode != null) {
      const qrCodeArr = qrCode.split('_');
      const PACode = qrCodeArr[1];
      prequalSource = qrCodeArr[0];
      dispatch(updatePrequalSource(prequalSource));
      dispatch(updateTier3PACode(PACode));
    }
    appConfig = loadConfig(window.location.host);
  }
  const [maintenanceStatus, setMaintenanceStatus] = useState(false);
  const [maintenanceEndTime, setMaintenanceEndTime] = useState('');

  listenTier3ModalEventOpen(dispatch, customerData);
  initializeAxiosInterceptor(customerData.uuid, prequalSource, window.location.pathname, appConfig.countryCode, languageCode);
  function createAdobeScriptTag() {
    const adobeScript = document.createElement('script');
    adobeScript.src = appConfig.adobeSrc;
    adobeScript.type = 'text/javascript';
    adobeScript.className = 'optanon-category-6';
    document.head.append(adobeScript);
  }

  useEffect(() => {
    if (pathname.toLowerCase().includes(SPECIAL_EVENT_PAGE_NAME.toLowerCase())) {
      dispatch(updateSpecialEvent(true));
      dispatch(updateOptimizelyExperimentData({}));
    } else {
      dispatch(updateSpecialEvent(false));
    }
  }, [pathname]);

  useEffect(() => {
    if (customerData.indexSource.value === 'componentButton' && !customerData.showModalFlag.value) {
      loadCustomerDataFromInput(prequalSource, prequalInput, customerData, dispatch);
      dispatch(updateShowModalFlag(true));
    } else if (customerData.indexSource.value === 'componentBasic') {
      loadCustomerDataFromInput(prequalSource, prequalInput, customerData, dispatch);
    }
  }, [customerData.indexSource.value]);

  useEffect(() => {
    const getMaintenanceStatus = async () => {
      try {
        const response = await getMaintenanceStatusService(appConfig);
        const status = response?.data.maintenanceStatus;
        setMaintenanceStatus(status);
        const maintenanceEndMinute = String(response?.data.maintenanceEndMinute).padStart(2, '0');
        if (status) {
          const utcTime = `${parseInt(response?.data.maintenanceEndHour, 10) - 4}:${maintenanceEndMinute}`;
          setMaintenanceEndTime(utcTime);
        }
      } catch (error) {
        setMaintenanceStatus(false);
      } finally {
        setApiLoading(false);
      }
    };
    getMaintenanceStatus();
    const getConfig = async () => {
      try {
        const response = await getConfigService(appConfig);
        const uiConfig = response?.data
        dispatch(updateConfig(uiConfig));
      } catch (error) {
        dispatch(updateConfig({}));
      }
    }
    getConfig();
    createAdobeScriptTag();
    initializeMouseflow(appConfig);
    dispatch(updateCountryCode(appConfig.countryCode));
    if (!prequalSource) {
      reloadFn();
    }
    dispatch(updateHighestPageHit(customerData));
    dispatch(updateHighestPageHit(customerData));
    dispatch(updateModalUpdateFlag(appConfig.modalUpdateFlag));
    dispatch(updateLanguageCode(languageCode));
  }, []);

  return (
    <>
      {!apiLoading && <div id='prequal--web--app' data-testid='main-container'>
          <main className={`prequal--web--app ${customerData.isDealerHostApplication.value || isDealerHost ? 'prequal--wc--app' : ''}`}>
            <PrequalRouteSwitch customerData={customerData} dispatch={dispatch} appConfig={appConfig} maintenanceStatus={maintenanceStatus} maintenanceEndTime={maintenanceEndTime}/>
          </main>
      </div>
      }
    </>
  );
}

export default App;
